export default __webpack_public_path__ + "static/about-bg-0722d16493b63b2465a789fb92b1f409.jpg";